import { render } from "./MdlEtiquetas.vue?vue&type=template&id=726b1233&scoped=true"
import script from "./MdlEtiquetas.vue?vue&type=script&lang=js"
export * from "./MdlEtiquetas.vue?vue&type=script&lang=js"

import "./MdlEtiquetas.vue?vue&type=style&index=0&id=726b1233&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726b1233"]])

export default __exports__